import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import TrackVisibility from 'react-on-screen';
import { translate } from '@fiverr-private/i18n-react';
import ListItem from './ListItem';
import { SECTION_KEYS, HOW_DOES_IT_WORK_CONTENT } from './constants';
import './style.scss';

const HowDoesItWork = ({
    className = '',
    sectionsKey = SECTION_KEYS.SELLER,
    i18nPrefix = '',
    getStartedUrl = '',
    getStartedClick = noop,
    isMobileOrTablet = false,
    tagName,
    ideasData,
}) => {
    const VISIBILITY_OFFSET = isMobileOrTablet ? 0 : 100;

    return (
        <div className={classnames('how-does-it-work', className)}>
            {ideasData ? (
                <>
                    <h2 className="text-display-2">{ideasData.title}</h2>
                    <p className="ideas-subtitle">{ideasData.subtitle}</p>
                </>
            ) : (
                <h2 className="text-display-2">{translate(`${i18nPrefix}.how_does_it_work.section_title`)}</h2>
            )}
            <ul>
                {HOW_DOES_IT_WORK_CONTENT[sectionsKey].map((section) => (
                    <TrackVisibility offset={VISIBILITY_OFFSET} once tag="li" key={section.id}>
                        <ListItem
                            section={section}
                            tagName={tagName}
                            isMobileOrTablet={isMobileOrTablet}
                            i18nPrefix={i18nPrefix}
                            getStartedUrl={getStartedUrl}
                            getStartedClick={getStartedClick}
                        />
                    </TrackVisibility>
                ))}
            </ul>
        </div>
    );
};

HowDoesItWork.propTypes = {
    className: PropTypes.string,
    sectionsKey: PropTypes.oneOf([SECTION_KEYS.SELLER, SECTION_KEYS.BUYER, SECTION_KEYS.IDEAS]),
    i18nPrefix: PropTypes.string,
    getStartedUrl: PropTypes.string,
    getStartedClick: PropTypes.func,
    isMobileOrTablet: PropTypes.bool,
    tagName: PropTypes.string,
    ideasData: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
    }),
};

export default HowDoesItWork;
